type TranslationValue = string | number | boolean | Date | null | undefined;

export type CouponErrorLike = {
  Message?: string;
  Type?: string;
};

export function getCouponErrorMessage(
  error: CouponErrorLike,
  t: (key: string, values?: Record<string, TranslationValue>) => string,
  code?: string
): string {
  switch (error.Type) {
    case "Discounts:CouponAlreadyAdded":
      return t("error.coupon_already_added");
    case "Discounts:InvalidCoupon":
      return t("error.invalid_coupon", { code });
    default:
      return error.Message || t("error.invalid_coupon", { code });
  }
}
